import React from "react";
import "./HeroSection.css";

const HeroSection = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero-section" id="herosection">
      
      <div className="hero-content">
        <h1>
          Expand into India With Ease – From Shipping to Sales, We Handle the Heavy Lifting
        </h1>
        <p>
          Unlock the Indian market with our all-in-one infrastructure.
          Whether you're just starting or ready to scale, we’ve got a plan built for you.
          <span className="highlight"> Indvo is your trusted partner.</span>
        </p>
        <div className="hero-buttons">
          <button className="hero-button primary" onClick={scrollToContact}>
            Start Free Trial
          </button>
          {/* <button className="hero-button secondary">
            Download Market Trends Guide
          </button> */}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
